<template>
    <div>
        <OptionsSelectorComponent ref="OptionsSelectorRef" :text_select="text_list.title" :text_list="text_list.subtitle" :options_list="options_list" :view_class_view="view_class_view_option_selector" :colors_options="['bg-white text-black','bg-white text-black']" />
        <div :class="view_class_view.div_container_error.container" v-for="(error,index) of moduleValidationModelValidations.selection_list.$errors" :key="index">
            <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
        </div> 
    </div>
</template>

<script>
import { ref } from 'vue';
import { requiredIf, helpers } from "@vuelidate/validators";
import useVuelidate from '@vuelidate/core';

import OptionsSelectorComponent from "./../Forms/OptionSelector.vue";

export default {
    name: "QuotationCheckbtnTextSelect",
    props: {
        text_select: {
            type: Object,
            required: true,
            default(){
                return  {}
            }
        },
        text_list: {
            type: String,
            required: true,
            default(){
                return  ''
            }
        },
        options_list: {
			type: Object,
			default(){
				return {
					options: [],
					selected: []
				}
			}
		},
        activation_value: {
            required: true,
            default(){
                return ""
            }
        },
        validations: {
            type: Object,
            required: true,
            default(){
                return  {
                    selection_list: {
                        required: helpers.withMessage("El campo es requerido", requiredIf(true))
                    }
                };
            }
        },
        buttons_styles: {
            type: Object,
            default(){
                return {
                    buttonSelected:"",
                    activeColorBackground: '',
                    inactiveColorBackground: '',
                    activeColorText: '',
                    inactiveColorText: '',
                    activeBorderColor: '',
                    inactiveBorderColor: ''
                }
            }
        },
        view_class_view: {
            type: Object,
            default(){
                return {
                    div_container_error:{
                        container:"my-2",
                        text_error:"text-red-600",
                    },
                };
            }
        }
    },
    setup(props){
        let OptionsSelectorRef = ref(null);

        let moduleValidationModel  = ref({
            selection_list: ""
        });
        
        let moduleValidationModelValidations = useVuelidate(props.validations, moduleValidationModel);

        let view_class_view_option_selector = {
            label: "font-medium	",
            select: "",
            div_container: "",
            list: "w-full p-2 outline-transparent ring-transparent focus:outline-none border-2 focus:ring focus:border-cherryColor active:border-cherryColor rounded-sm w-full mt-2",
        };

        function execute_validation(){
            let OptionsSelectorRefs = OptionsSelectorRef.value.execute_validation();
            moduleValidationModelValidations.value.$validate();
            if(moduleValidationModelValidations.value.$error && !OptionsSelectorRefs) return false;
            
            moduleValidationModel.value.selection_list = OptionsSelectorRefs;
            return moduleValidationModel.value;
        }
        
        return {
            moduleValidationModel,
            moduleValidationModelValidations,
            view_class_view_option_selector,
            execute_validation,
            OptionsSelectorRef
        };
    },
    components: {
        OptionsSelectorComponent,
    }
}

</script>